// extracted by mini-css-extract-plugin
export var container = "galleryImageCard-module--container--e4f59";
export var containerDescription = "galleryImageCard-module--containerDescription--9ce51";
export var description = "galleryImageCard-module--description--a7c49";
export var image = "galleryImageCard-module--image--8cf35";
export var title = "galleryImageCard-module--title--c7f15";